import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ReactGA from "react-ga";
import util from "../lib/util";
import Panel from "react-bootstrap/lib/Panel";
import $ from "jquery";
//Components
import MainContent from "./Sections/MainPage/MainContent";
import ConfirmationPage from "./Sections/MainPage/ConfirmationPage";
import OffRampSubmitted from "./Sections/ServiceAddress/OffRampSubmitted";
import { nextStepClicked } from "../actions";
import { browserHistory } from "react-router";

class Steps extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      isGoogleAnalyticsLoaded: false,
      isFaqOpen: false,
      steps: props.steps,
    };
  }

  componentWillReceiveProps(p) {
    if (p.activeIndex != this.state.activeIndex) {
      this.setState({ activeIndex: p.activeIndex });
      this.state.steps.map((x, i) => {
        x.IsCompleted = i < p.activeIndex;
      });
      util.trackGoogleAnalytics(
        p.pageName,
        "Steps",
        this.state.steps[p.activeIndex].stepTitle,
        p.activeIndex
      );
    }
    if (p.isLoggedIn) {
      if (p.activeIndex == 0 && p.isCopy && !p.isRefresh) {
        const url = window.location.href + "&isRefresh=true";
        window.location.href = url;
      }
      this.state.steps.map((x) => {
        if (x.stepTitle == "Create an online profile") {
          const newState = this.state.steps;
          if (newState.indexOf(x) > -1) {
            newState.splice(newState.indexOf(x), 1);
            this.setState({ steps: newState });
          }
        }
      });
    }
    const googleAnalyticsId = window.osa && window.osa.googleAnalyticsId;
    if (googleAnalyticsId && !this.state.isGoogleAnalyticsLoaded) {
      // initialize & add event to google analytics
      ReactGA.initialize(googleAnalyticsId);
      util.trackGoogleAnalytics(p.pageName, "Steps", "Service address", 0);
      this.setState({ isGoogleAnalyticsLoaded: true });
    }

    if (p.isProjectCancelled) {
      util.trackGoogleAnalytics(
        this.props.pageName,
        "Project Cancelled",
        "Project Cancelled from Steps"
      );
      p.onCancelSuccess();
      this.onCancelRedirect(p);
    }
  }

  onCancelClick = () => {
    const p = this.props;
    const modalLookup = window.osa && window.osa.commonLookup.modal;
    const data = {
      headerText: modalLookup.cancelService.header,
      bodyText: modalLookup.cancelService.body,
      actionButtonText: "OK",
      closeButtonText: "Cancel",
      onActionClicked: () => {
        if (p.projectNo) {
          let model = {
            ProjectNo: p.projectNo,
          };
          p.onCancelProject(model);
        } else {
          this.onCancelRedirect(p);
        }
      },
    };
    this.props.onShowModal(data);
  };

  onCancelRedirect = (p) => {
    if (p.isLoggedIn) browserHistory.push("/dashboard");
    else window.location.href = "https://www.fortisbc.com";
  };

  nextStep = (activeIndex) => {
    return function () {
      if (activeIndex >= 0) this.setState({ activeIndex });

      this.state.steps.map((x, i) => {
        x.IsCompleted = i < activeIndex;
      });

      this.props.onNextStepClicked(activeIndex);
    }.bind(this);
  };

  render() {
    const p = this.props;
    const s = this.state;
    if (p.isProjectSubmited)
      //scroll to top of page on submited project page(confirmation)
      $("body, html").animate({ scrollTop: 0 }, 500);
    const enterToPanel = (i) => {
      //for scroll the page to top of panel
      $("body, html").animate(
        { scrollTop: $("#" + i.id).offset().top - 45 },
        500
      );
    };
    let steps = s.steps.map((x, i) => {
      const headerName = "Step " + (i + 1) + ": " + x.stepTitle;
      const Step = s.steps[i].stepName;
      let title = (
        <span>
          <b>Step {i + 1}:</b> {x.stepTitle}
        </span>
      );
      if (x.IsCompleted) {
        title = (
          <div>
            <span className="glyphicon glyphicon-ok text-success" /> {title}
          </div>
        );
      }
      return (
        <Panel
          onEntered={enterToPanel}
          id={"step" + (i + 1)}
          key={i}
          header={title}
          eventKey={i}
          className={
            i == s.activeIndex
              ? "panel-primary step-title"
              : "panel-default step-title"
          }
        >
          {i != s.activeIndex && i != 0 ? null : ( //there is no need to always load all the steps, step one is exceptional because of google map
            <Step
              {...p}
              id={headerName}
              onNextClick={this.nextStep(i + 1)}
              onBackClick={this.nextStep(i - 1)}
              onCancelClick={this.onCancelClick}
            />
          )}
        </Panel>
      );
    });
    const activePageTitle = s.steps[s.activeIndex].stepTitle;
    return p.isOffRampSubmitted ? (
      <OffRampSubmitted />
    ) : (
      <div>
        {p.isProjectSubmited ? (
          <ConfirmationPage />
        ) : (
          <div>
            <MainContent
              steps={steps}
              activeIndex={s.activeIndex}
              activePageTitle={activePageTitle}
            />
          </div>
        )}
      </div>
    );
  }
}
Steps.propTypes = {
  isOffRampSubmitted: PropTypes.bool,
  isProjectSubmited: PropTypes.bool,
  isProjectCancelled: PropTypes.bool,
  activeIndex: PropTypes.number,
  isLoggedIn: PropTypes.bool,
  isCopy: PropTypes.bool,
  isRefresh: PropTypes.bool,
  onNextStepClicked: PropTypes.func,
  projectNo: PropTypes.string,
  onShowModal: PropTypes.func,
  pageName: PropTypes.string,
  steps: PropTypes.array,
};
function mapDispatchToProps(dispatch) {
  return {
    onNextStepClicked: (activeIndex) => dispatch(nextStepClicked(activeIndex)),
    onShowModal: (data) => dispatch({ type: "SHOW_MODAL", data: data }),
    onCancelProject: (model) =>
      dispatch({ type: "CANCEL_PROJECT", model: model }),
    onCancelSuccess: () =>
      dispatch({ type: "CANCELLED_PROJECT", cancelledProject: null }),
  };
}
const mapStateToProps = (state) => {
  return {
    isOffRampSubmitted: state.gas.reqcall && state.gas.reqcall.isSuccess,
    isProjectSubmited:
      state.gas.submittedProject && state.gas.submittedProject.isSuccess,
    isProjectCancelled:
      state.gas.cancelledProject && state.gas.cancelledProject.isSuccess,
    activeIndex: state.gas.activeIndex,
    pageName: state.gas.pageName,
    isLoggedIn: state.gas.user && state.gas.user.isAuthenticated,
    projectNo:
      state.gas.project &&
      state.gas.project.data &&
      state.gas.project.data.projectNo,
    isCopy:
      state.routing.locationBeforeTransitions &&
      state.routing.locationBeforeTransitions.query["isCopy"],
    isRefresh:
      state.routing.locationBeforeTransitions &&
      state.routing.locationBeforeTransitions.query["isRefresh"],
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Steps);
